import { first } from 'lodash';
import { CuisineCategory, RegionInfo } from 'src/gqlReactTypings.generated.d';
import { UseDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { match, P } from 'ts-pattern';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { PageHeroType } from '../Constants';

export type UsePageHeroProps = {
  activeCuisineCategory: CuisineCategory | null;
  isCuisineSegment?: boolean;
  isPageLoading?: boolean;
  showRecommendedShefsLayout?: boolean;
  region?: Pick<RegionInfo, 'id' | 'isVerifiedHalalEnabled'>;
  filters: UseDishFirstExploreUrl;
};

export const usePageHeroType = (props: UsePageHeroProps) => {
  const {
    activeCuisineCategory,
    isCuisineSegment = false,
    isPageLoading = false,
    showRecommendedShefsLayout = false,
    region,
    filters,
  } = props;

  const pageHeroType = match({
    hasCuisineCommunityPage: !!activeCuisineCategory?.categoryPageContent,
    isPageLoading,
    browseFilter: filters.browseFilter,
    dietaryFilter: first(filters.dietaryFilters),
    isCuisineSegment,
    showRecommendedShefsLayout,
    isVerifiedHalalEnabled: region?.isVerifiedHalalEnabled,
  })
    .with(
      {
        dietaryFilter: DietaryTags.HALAL,
        isVerifiedHalalEnabled: true,
      },
      () => PageHeroType.VerifiedDietaryPage
    )
    .with({ hasCuisineCommunityPage: true, browseFilter: P.not(P.nullish) }, () => PageHeroType.CuisineCategoryPage)
    .with(
      { isPageLoading: false, browseFilter: P.not(P.nullish), showRecommendedShefsLayout: true },
      () => PageHeroType.FilterBannerRecommendedShefs
    )
    .with({ isPageLoading: false, browseFilter: P.not(P.nullish) }, () => PageHeroType.FilterBanner)
    .with({ isPageLoading: false, isCuisineSegment: false, showRecommendedShefsLayout: false }, () => PageHeroType.Main)
    .with({ isPageLoading: false, showRecommendedShefsLayout: true }, () => PageHeroType.RecommendedShefs)
    .otherwise(() => PageHeroType.Loading);

  const isPageHeroFilterBanner = pageHeroType === PageHeroType.FilterBanner;
  const isPageHeroLoading = pageHeroType === PageHeroType.Loading;
  const isPageHeroMain = pageHeroType === PageHeroType.Main;
  const isPageHeroFilterBannerRecommendedShefs = pageHeroType === PageHeroType.FilterBannerRecommendedShefs;

  return {
    pageHeroType,
    isPageHeroFilterBanner,
    isPageHeroLoading,
    isPageHeroMain,
    showBrowseFilterBanner: isPageHeroFilterBanner || isPageHeroFilterBannerRecommendedShefs,
    activeCuisineCategory,
  };
};
